import { AppState } from 'Store'

const selectCodeEmail = (state: AppState) => state.modules.email_neo.codes
const selectLogs = (state: AppState) => state.modules.email_neo.logs
const getEmailSelector = (state: AppState) => state.modules.email_neo.email

export const codeEmailSelectors = {
	selectCodeEmail,
	selectLogs,
	getEmailSelector,
}
